import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslationPipe } from '../../../pipes/translation.pipe';

@Component({
  selector: 'app-download-wait-dialog',
  templateUrl: './download-wait-dialog.component.html',
  styleUrls: ['./download-wait-dialog.component.scss'],
  imports: [ProgressSpinnerModule, TranslationPipe],
  providers:[TranslationPipe]
})
export class DownloadWaitDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
